import "./App.css";
import Main from "./components/Main/Main";

function App() {
  return (
    <div className="container">
      <Main />
    </div>
  );
}

export default App;
